import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GuardLinkService {
  isValidLink = false;

  redirectUrl: string;

  constructor() { }

  validateLink(): Observable<boolean> {
    return of(true).pipe(
      delay(1), tap(val => this.isValidLink = true)
    );
  }

  invalidateLink(): void {
    this.isValidLink = false;
  }
}
